import { render } from "./UsersForm.vue?vue&type=template&id=00fc0817"
import script from "./UsersForm.vue?vue&type=script&lang=js"
export * from "./UsersForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__